<template>  
<div> <!-- root element start -->
    <div  class="row" v-if="specificComp == 0">
      <div class="col-12 mt-4">
        <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
      </div>
    </div>
    <div v-if="specificComp == 1" class="row">
      <div class="col-12">
        <div class="card border-0">
          <div class="card-header h5 bg-transparent border-0">Create a Product</div>
          <div class="card-body">

              <div class="row mb-3">

                <div class="col-lg-6 mb-3 mb-md-0">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label class="input-group-text" for="inputGroupSelect01">Name</label>
                    </div>
                    <input type="text" class="form-control" v-model="name">
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label class="input-group-text" for="inputGroupSelect01">P/N</label>
                    </div>
                    <input type="text" class="form-control" v-model="part_number">
                  </div>
                </div>

              </div>

              <div class="row mb-3">

                <div class="col-lg-12">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label class="input-group-text" for="inputGroupSelect01">Long Name</label>
                    </div>
                    <input type="text" class="form-control"  v-model="desc_name">
                  </div>
                </div>

              </div>

              <div class="row mb-3">

                <div class="col-lg-12">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <label class="input-group-text" for="inputGroupSelect01">Description</label>
                    </div>
                    <textarea class="form-control" v-model="description"></textarea>
                  </div>
                </div>

              </div>
              <hr>
              <div class="row mb-3">

                <div class="col-lg-12">
                  <button @click="submitForm" class="btn btn-success">Submit</button>
                  <button @click="resetForm" class="btn btn-primary">Reset</button>
                  <button @click="cancelForm" class="btn btn-danger">Cancel</button>
                </div>

              </div>

          </div>
        </div>
      </div>
    </div>


</div> <!-- root element end -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/admin-user-store.js'


// import catMain from '../InstComponents/CategoryComponents/category-main.vue'


export default {

  data: function () {
    return { 
      name: '',
      desc_name: '',
      part_number: '',
      description: '',
    }
  },
  computed: {
    specificData () { return this.$store.state.productList },
    specificComp () { return this.$store.state.productComp },
  },
  watch: {
    
  },
  mounted() {
    
  },
  methods: {
    changeRightView(name, prop1, prop2) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2 }); },
    cancelForm(){
      var _this = this;
      _this.$emit('onUComplete', ['product-create']);
    },
    resetForm(){
      var _this = this;
      _this.name = '';
      _this.desc_name = '';
      _this.part_number = '';
      _this.description = '';
    },
    validateForm() {
      var _this = this;
      var valErrors = [];

      if(_this.name == '' || _this.name == null){ valErrors.push("A name is required!")  } 
      if(_this.desc_name == '' || _this.desc_name == null){ valErrors.push("A descriptive name is required!")  } 
      if(_this.part_number == '' || _this.part_number == null){ valErrors.push("A part number is required!")  } 
      if((_this.description != '' && _this.description != null) && _this.description.length < 10 ){ valErrors.push("A description is not required, but if entered, a valid description of at least two characters is required!")  } 

      if( valErrors.length > 0) {
        _this.errorDisplay(valErrors);
        return false;
      } else {
        return true;
      }
    },
    submitForm() {
      var _this = this;
      var a = _this.validateForm();
      if(a == false) {
        return false;
      }
      _this.$toastr.warning('Sending new user information.', 'Please wait!')
      axios.post( '/admin/utility/product/storeproduct', {
        name: _this.name,
        desc_name: _this.desc_name,
        part_number: _this.part_number,
        description: _this.description,
      })
      .then(function(response){
        var msg = response.data.msg;
        _this.$toastr.remove()
        _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
        _this.$emit('onSComplete', ['product-create']);
      }) //end then
      .catch(function (error) {
        var errors = error.response.data.errors;
        _this.errorDisplay(errors);
      })
    },

    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    }
  },    
  components:{
    ScalingSquaresSpinner
  },
  filters: {

  }
}
</script>
